// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"39615c89","239":"86244078","453":"564ac860","732":"d02c16b4"}[chunkId] + ".chunk.js";
};